export default __webpack_public_path__ + "static/media/000_Muenter_Dynastie_Sample.e7c73faf.mp3";